export class Personaldata {
    constructor(preopen = 0, openProfil = 0) {
        this.loginFormSubmit = document.querySelector('#loginFormSubmit');
        this.loginFormBack = document.querySelector('#loginFormBack');
        this.loginFormToggle = document.querySelector('#loginFormToggle');
        this.loginForm = document.querySelector('#loginForm');

        this.passwordFormSubmit = document.querySelector('#passwordFormSubmit');
        this.passwordFormBack = document.querySelector('#passwordFormBack');
        this.passwordFormToggle = document.querySelector('#passwordFormToggle');
        this.passwordForm = document.querySelector('#passwordForm');

        this.profilFormSubmit = document.querySelector('#profilFormSubmit');
        this.profilFormBack = document.querySelector('#profilFormBack');
        this.profilFormToggle = document.querySelector('#profilFormToggle');
        this.profilForm = document.querySelector('#profilForm');

        this.profilUpgradeSubmit = document.querySelector('#profilUpgradeSubmit');
        this.profilUpgradeForm = document.querySelector('#profilUpgradeForm');

        this.init(preopen, openProfil);
    };

    init(preopen, openProfil) {
        if(this.profilUpgradeSubmit) {
            this.profilUpgradeSubmit.addEventListener('click', event => {
                event.preventDefault();
                this.reset();
                this.upgradeProfil();
            });
        }

        if(this.loginForm) {
            this.loginFormSubmit.addEventListener('click', event => {
                event.preventDefault();
                this.reset();
                this.updateLogin();
            });

            this.loginFormBack.addEventListener('click', event => {
                event.preventDefault();
                this.hideForm(this.loginForm, this.loginFormToggle);
            });

            this.loginFormToggle.addEventListener('click', event => {
                event.preventDefault();
                this.showForm(this.loginForm, this.loginFormToggle);
            });
        }

        if(this.passwordForm) {
            this.passwordFormSubmit.addEventListener('click', event => {
                event.preventDefault();
                this.reset();
                this.updatePassword();
            });

            this.passwordFormBack.addEventListener('click', event => {
                event.preventDefault();
                this.hideForm(this.passwordForm, this.passwordFormToggle);
            });

            this.passwordFormToggle.addEventListener('click', event => {
                event.preventDefault();
                this.showForm(this.passwordForm, this.passwordFormToggle);
            });
        }

        if(this.profilForm) {
            this.profilFormSubmit.addEventListener('click', event => {
                event.preventDefault();
                this.reset();
                this.updateProfil();
            });

            this.profilFormBack.addEventListener('click', event => {
                event.preventDefault();
                this.hideForm(this.profilForm, this.profilFormToggle);
            });

            this.profilFormToggle.addEventListener('click', event => {
                event.preventDefault();
                this.showForm(this.profilForm, this.profilFormToggle);
            });

            if(preopen) {
                this.showForm(this.profilForm, this.profilFormToggle);
            }
        }

        let tooltips = document.querySelectorAll('.infoTooltip');
        if(tooltips) {
            tooltips.forEach(tooltip => {
                new bootstrap.Tooltip(tooltip);
            });
        }

        if(openProfil) {
            this.showForm(this.loginForm, this.loginFormToggle);
        }
    };

    showForm(form, button) {
        form.classList.remove('d-none');
        button.classList.add('d-none');
    }

    hideForm(form, button) {
        form.classList.add('d-none');
        button.classList.remove('d-none');
    }

    updateLogin() {
        let request = new Request('POST', this.loginForm.getAttribute('action'));
        request.formData = this.loginForm;
        request.call((response) => {
            if(response.status == 'ok') {
                window.location.replace(response.redirect);
            } else {
                this.error('login', response.fields);
            }
        });
    };

    updatePassword() {
        let request = new Request('POST', this.passwordForm.getAttribute('action'));
        request.formData = this.passwordForm;
        request.call((response) => {
            if(response.status == 'ok') {
                window.location.replace(response.redirect);
            } else {
                this.error('password', response.fields);
            }
        });
    };

    updateProfil() {
        let request = new Request('POST', this.profilForm.getAttribute('action'));
        request.formData = this.profilForm;
        request.call((response) => {
            if(response.status == 'ok') {
                window.location.replace(response.redirect);
            } else {
                this.error('profil', response.fields);
            }
        });
    };

    upgradeProfil() {
        let request = new Request('POST', this.profilUpgradeForm.getAttribute('action'));
        request.formData = this.profilUpgradeForm;
        request.call((response) => {
            if(response.status == 'ok') {
                window.location.replace(response.redirect);
            } else {
                this.error('profil', response.fields);
            }
        });
    };

    error(service, errors) {
        errors.forEach(error => {
            let element = document.querySelector('.field-' + service + '-' + error.input + ' > div.text-danger');
            if(element) element.innerHTML = error.message;
        });
    };

    reset() {
        let elements = document.querySelectorAll('div.text-danger');
        elements.forEach(element => {
            element.innerHTML = '';
        });
    }
};
